<div class="my-16">
  <section class="padding2 space-y-16">
    <h1 class="text-2xl lg:text-5xl text-center">
      Find Your Next Seafarer Job with Leading Maritime Companies
    </h1>
    <div *ngIf="companies$ | async as companies" class="space-y-8">
      <app-company-card
        *ngFor="let company of companies"
        [item]="company"
      ></app-company-card>
    </div>
  </section>
</div>
